import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { BinaryReader } from "../../../binary";
import { MsgRegisterFeePayContract, MsgRegisterFeePayContractResponse, MsgUnregisterFeePayContract, MsgUnregisterFeePayContractResponse, MsgFundFeePayContract, MsgFundFeePayContractResponse, MsgUpdateFeePayContractWalletLimit, MsgUpdateFeePayContractWalletLimitResponse, MsgUpdateParams, MsgUpdateParamsResponse } from "./tx";
/** Msg defines the fees Msg service. */

export class MsgClientImpl {
  constructor(rpc) {
    _defineProperty(this, "rpc", void 0);
    this.rpc = rpc;
    this.registerFeePayContract = this.registerFeePayContract.bind(this);
    this.unregisterFeePayContract = this.unregisterFeePayContract.bind(this);
    this.fundFeePayContract = this.fundFeePayContract.bind(this);
    this.updateFeePayContractWalletLimit = this.updateFeePayContractWalletLimit.bind(this);
    this.updateParams = this.updateParams.bind(this);
  }
  registerFeePayContract(request) {
    const data = MsgRegisterFeePayContract.encode(request).finish();
    const promise = this.rpc.request("juno.feepay.v1.Msg", "RegisterFeePayContract", data);
    return promise.then(data => MsgRegisterFeePayContractResponse.decode(new BinaryReader(data)));
  }
  unregisterFeePayContract(request) {
    const data = MsgUnregisterFeePayContract.encode(request).finish();
    const promise = this.rpc.request("juno.feepay.v1.Msg", "UnregisterFeePayContract", data);
    return promise.then(data => MsgUnregisterFeePayContractResponse.decode(new BinaryReader(data)));
  }
  fundFeePayContract(request) {
    const data = MsgFundFeePayContract.encode(request).finish();
    const promise = this.rpc.request("juno.feepay.v1.Msg", "FundFeePayContract", data);
    return promise.then(data => MsgFundFeePayContractResponse.decode(new BinaryReader(data)));
  }
  updateFeePayContractWalletLimit(request) {
    const data = MsgUpdateFeePayContractWalletLimit.encode(request).finish();
    const promise = this.rpc.request("juno.feepay.v1.Msg", "UpdateFeePayContractWalletLimit", data);
    return promise.then(data => MsgUpdateFeePayContractWalletLimitResponse.decode(new BinaryReader(data)));
  }
  updateParams(request) {
    const data = MsgUpdateParams.encode(request).finish();
    const promise = this.rpc.request("juno.feepay.v1.Msg", "UpdateParams", data);
    return promise.then(data => MsgUpdateParamsResponse.decode(new BinaryReader(data)));
  }
}